import {
  Box,
  Button,
  Flex,
  Text,
  Input,
  Select,
  Radio,
  RadioGroup,
  Stack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  InputGroup,
  InputLeftElement,
  TableContainer
} from "@chakra-ui/react";
import { LuSearch } from "react-icons/lu";
import { useState } from "react";

const Requests = () => {
  const [radioValue, setRadioValue] = useState("all");

  // Dummy data for table rows
  const requestData = [
    {
      requestType: "Artwork",
      overview: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      priority: "Low",
      submitted: "21/10/24",
      client: "HSBC – Joanna Bloggs",
      assigned: "Unassigned",
    },
    {
      requestType: "Quote",
      overview: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      priority: "Low",
      submitted: "21/10/24",
      client: "HSBC – Joanna Bloggs",
      assigned: "me",
    },
    {
      requestType: "Low stock",
      overview: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      priority: "Low",
      submitted: "21/10/24",
      client: "HSBC – Joanna Bloggs",
      assigned: "Lana Steiner",
    },
    {
      requestType: "General",
      overview: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      priority: "Low",
      submitted: "21/10/24",
      client: "HSBC – Joanna Bloggs",
      assigned: "Lana Steiner",
    },
  ];

  return (
    <Box flex="1" pt="40px" px={{ base: "4", md: "8" }}>
      {/* Header */}
      <Flex justify="space-between" align="center" mb={6} flexWrap="wrap">
        <Text fontSize="30px" color="#101828">
          Requests
        </Text>
        <Button
          background="#1e98d7"
          color="#ffffff"
          _hover="none"
          fontSize="14px"
          width=""
        >
          Create a New Request
        </Button>
      </Flex>

      {/* Filters Section */}
      <Flex
        gap={4}
        wrap="wrap"
        mb={6}
        direction={{ base: "column", md: "row" }}
      >
         <InputGroup flex="1" maxW={{ base: "180px", md: "270px" }}>
          <InputLeftElement pointerEvents="none">
            <LuSearch color="#999999" />
          </InputLeftElement>
          <Input placeholder="Search" fontSize="12px" />
        </InputGroup>
        
        <Select
          placeholder="Request type (0)"
          fontSize="12px"
          color="#667085"
          width="180px"
        >
          <option value="option1">Artwork</option>
          <option value="option2">Quote</option>
        </Select>
        <Select
          placeholder="Priority (0)"
          fontSize="12px"
          color="#667085"
          width="180px"
        >
          <option value="pending">Low</option>
          <option value="approved">High</option>
        </Select>
        <Select
          placeholder="Client (0)"
          fontSize="12px"
          color="#667085"
          width="180px"
        >
          <option value="pending">Low</option>
          <option value="approved">High</option>
        </Select>
      </Flex>

      {/* Radio Buttons */}
      <RadioGroup onChange={setRadioValue} value={radioValue} mb={12} color="#475467">
        <Stack direction="row" align="center">
          <Text fontWeight="semibold" fontSize="12px" color="#475467" mr={4}>
            View:
          </Text>
          <Radio
            value="all"
            mr={4}
          >
            <Text fontSize="12px">All requests</Text>
          </Radio>
          <Radio
            value="approved"
            mr={4}
          >
            <Text fontSize="12px">My requests</Text>
          </Radio>
          <Radio
            value="pending"
          >
            <Text fontSize="12px">Unassigned requests</Text>
          </Radio>
        </Stack>
      </RadioGroup>

      {/* Responsive Table */}
      <Box overflowX="auto">
      <TableContainer>
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Request type
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Overview
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Priority
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Submitted
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Client
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              >
                Assigned to
              </Th>
              <Th
                pl={0}
                textTransform="none"
                color="#475467"
                fontSize="12px"
                fontWeight="semibold"
              ></Th>
            </Tr>
          </Thead>

          <Tbody>
            {requestData.map((request, index) => (
              <Tr key={index}>
                <Td pl={0} py={7} color="#475467" fontSize="12px">
                  {request.requestType}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.overview}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.priority}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.submitted}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.client}
                </Td>
                <Td pl={0} color="#475467" fontSize="12px">
                  {request.assigned}
                </Td>
                <Td
                  pl={0}
                  color="#475467"
                  fontSize="12px"
                  textDecoration="underline"
                  cursor="pointer"
                >
                  View
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default Requests;
